import { Injectable } from "@angular/core";
import { environment } from "@env/environment";

@Injectable({
    providedIn: 'root'
})
export class DtHelperService {

    public addDynatraceScript() {
        if (environment.dTMapfreScript && environment.dTAcmicScript) {
            const origin = window.location.origin;
            let isAcmic = false;
            if (origin.indexOf('acmic') > -1 || origin.indexOf('insure.wa.aaa') > -1) {
                isAcmic = true;
            }
            this.createAndAttachScriptTag(isAcmic, environment.dTAcmicScript, environment.dTMapfreScript);
        }

    }
    private createAndAttachScriptTag(isAcmic: boolean, dTAcmicScript, dTMapfreScript) {
        const script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', isAcmic ? dTAcmicScript : dTMapfreScript);
        script.setAttribute('crossorigin', 'anonymous');
        document.head.appendChild(script);
    }
}